define( [
	"./deletedIds"
], function( deletedIds ) {
	return deletedIds.indexOf;
} );



// WEBPACK FOOTER //
// ./~/jquery/src/var/indexOf.js